import React, { useContext } from "react";
import { Toggle } from "@fluentui/react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";
import { useTranslation } from "react-i18next";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import { getViewport, renderViewports } from "../../helpers/CornerstoneViewportService";
import dicomParser from 'dicom-parser';
import axiosInterceptor from "../../../../helpers/Interceptor";
import { loadAndCacheImage } from "@cornerstonejs/core/loaders/imageLoader";
import { annotation } from "@cornerstonejs/tools";
const MaskImageToggle = ({ isActiveImage, imageId }) => {
  const { themeName } = useContext(themeContext);
  const [t] = useTranslation();
  const { maskImages, setMaskImages , studyData} = useContext(studyviewerContext);
  const { activeViewportIndex, viewportSeriesData, disableMasking } = useContext(ViewportContext);





 const onToggleChange =  (event, checked) => {
  console.log(imageId);
  const imageIndexArray = imageId.split("_");
  

  if (!checked) {
    disableMasking();
    let isRender = false;
     for(const annotationdata in maskImages[imageId].maskAnnotationData){
        isRender = true;
        annotation.state.removeAnnotation(maskImages[imageId].maskAnnotationData[annotationdata].annotationUID);
    }
  
    setMaskImages(prevImages => {
      const updatedImages = { ...prevImages };
      delete updatedImages[imageId]; // Remove the entry
      return updatedImages;
    });
    if(isRender)
        renderViewports();
  } else {
    const updatedImageData = maskImages[imageId] || {
      maskAnnotationData: [],
      imageURL: studyData.stacks[imageIndexArray[0]].imageIds[imageIndexArray[1]],
    };

    const updatedEntry = {
      ...updatedImageData,
    };

    setMaskImages(prevImages => ({
      ...prevImages,
      [imageId]: updatedEntry,
    }));
  }
};


  return (
    <CustomToolTipHost content={isActiveImage ? "Unselect image" : "Select image"}>
      <Toggle
        checked={isActiveImage}
        onChange={onToggleChange}
      />
    </CustomToolTipHost>
  );
};

export default MaskImageToggle;
